import { Checkbox, IconButton, Stack, Text, TooltipHost } from "@fluentui/react";
import { useBreakpoint } from "../../../Common/Container/ContainerStyles";
import { BreakpointType } from "../../../Common/Container/ContainerFluid";
import { descriptionStyles, lgDescriptionStyles, lgTitleStyles, mdDescriptionStyles, mdTitleStyles, registerConfigurationAppTileContainerSelectedStyles, registerConfigurationAppTileContainerStyles, registerConfigurationAppTileInnerContainerSelectedStyles, registerConfigurationAppTileTextContainerStyles, smDescriptionStyles, smTitleStyles, titleStyles, xlDescriptionStyles, xlTitleStyles, xxlDescriptionStyles, xxlTitleStyles } from "../../../Common/Register/Components/Configuration/Styles/RegisterConfigurationStyles";
import { PartnerSubscriptionDetails } from "../../../../Model/PartnerModels";
import { PartnerConfigurationQuantityInput } from "./PartnerConfigurationQuantityInput";

export interface IPartnerConfigurationAppTileProps {
    app: PartnerSubscriptionDetails;
    priceString: string;
    onChange: (isSelected: boolean, quantity: number) => void;
}

export const PartnerConfigurationAppTile: React.FC<IPartnerConfigurationAppTileProps> = (props) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    const isDisabled = props.app.hidden || props.app.group === "OneShot";

    const onChangeAppSelection = (isSelected: boolean) => {
        let quantity = props.app.quantity;

        if (!isSelected && quantity > 0)
            quantity = 0;

        if (isSelected && quantity <= 0)
            quantity = 1;

        props.onChange(isSelected, quantity)
    }

    const onChangeAppQuantity = (quantity: number) => {
        let selected = props.app.selected;

        if (quantity <= 0 && selected)
            selected = false;

        if (quantity > 0 && !selected)
            selected = true;

        props.onChange(selected, quantity)
    }
    
    return (
        <Stack
            grow
            className={props.app.selected ? registerConfigurationAppTileContainerSelectedStyles : registerConfigurationAppTileContainerStyles}
        >
            <Stack
                grow
                horizontal
                horizontalAlign="space-between"
                verticalAlign="center"
                verticalFill
                className={props.app.selected ? registerConfigurationAppTileInnerContainerSelectedStyles : undefined}
            >
                <Stack
                    grow
                    horizontal
                    horizontalAlign="start"
                    verticalAlign="center"
                    verticalFill

                    className={registerConfigurationAppTileTextContainerStyles}
                >
                    <Checkbox
                        disabled={isDisabled}
                        checked={props.app.selected}
                        onChange={() => onChangeAppSelection(!props.app.selected)}
                    />
                    <Stack
                        verticalFill
                        verticalAlign="center"
                    >
                        <Text
                            className={
                                isSM ? 
                                    smTitleStyles : 
                                isMD ? 
                                    mdTitleStyles : 
                                isLG ?
                                    lgTitleStyles :
                                isXL ?
                                    xlTitleStyles :
                                isXXL ?
                                    xxlTitleStyles
                                :
                                    titleStyles
                            }
                        >
                            {props.app.description}
                        </Text>
                        <Text
                            className={
                                isSM ? 
                                    smDescriptionStyles : 
                                isMD ? 
                                    mdDescriptionStyles :
                                isLG ?
                                    lgDescriptionStyles :
                                isXL ?
                                    xlDescriptionStyles :
                                isXXL ?
                                    xxlDescriptionStyles
                                :
                                    descriptionStyles
                            }
                        >
                            {props.priceString}
                        </Text>
                    </Stack>
                </Stack>
                    {(!props.app.base && !isDisabled &&
                    <Stack>
                        <PartnerConfigurationQuantityInput quantity={props.app.quantity} onChange={onChangeAppQuantity}/>
                    </Stack>)}
                <Stack>
                    <TooltipHost
                        content={props.app.extendedDescription}
                        calloutProps={{ gapSpace: 0 }}
                        styles={{root:{display:'inline-block !important'}}}
                    >
                        <IconButton
                            iconProps={{ iconName: 'Info' }}
                        />
                    </TooltipHost>
                </Stack>
            </Stack>
        </Stack>
    );
}